.ProgressDetailedSkeleton__header {
    margin-bottom: 1.5rem;
}

.ProgressDetailedSkeleton__title {
    margin-bottom: 0.5rem;
}

.ProgressDetailedSkeleton__progressRow {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.ProgressDetailedSkeleton__progressBar {
    flex: 1;
}

.ProgressDetailedSkeleton__progressLabel {
    flex: 0 0 auto;
}

.ProgressDetailedSkeleton__tasks {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;

    @media (min-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.ProgressDetailedSkeleton__task {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1.25rem;
    min-height: 10rem;
}

.ProgressDetailedSkeleton__taskIcon {
    margin-bottom: 1rem;
    border-radius: 0.625rem;
}

.ProgressDetailedSkeleton__taskTitle {
    margin-bottom: 0.375rem;
}

.ProgressDetailedSkeleton__taskDescription {
    flex-grow: 1;
}
